import { types, getParent } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync, createSilentAsync } from 'src/utils/asyncModel';
const getFileInfoAsync = createAsync(body => {
  return async function getFileInfo(options) {
    const resp = await api.FileApi.getFileInfo(body, options);
    return resp;
  };
});
const uploadFileAsync = createAsync(body => {
  return async function uploadFile(options) {
    const resp = await api.FileApi.uploadFile(body, options);
    return resp;
  };
});
const deleteFileAsync = createAsync(body => {
  return async function deleteFile(options) {
    const resp = await api.FileApi.deleteFile(body, options);
    return resp;
  };
});
const getFilesInfoAsync = createAsync(body => {
  return async function getFilesInfo(options) {
    const resp = await api.FileApi.getFilesInfo(body, options);
    const _getParent = getParent(this),
      files = _getParent.files;
    files.setFileNamesByIds(resp);
    return resp;
  };
});
const uploadFileViaPresignedUrlExperimentAsync = createAsync(body => {
  return async function uploadFileViaPresignedUrlExperiment(options) {
    const resp = await api.FileApi.uploadFileViaPresignedUrl(body, options);
    return resp;
  };
});

/**
 * The same two uploads, silent: for a caller that retries them and says itself what happened once it is done,
 * so a failure a later attempt recovers from never reaches the person as an error (apply billing's copy).
 */
const uploadFileSilentAsync = createSilentAsync(body => {
  return async function uploadFileSilent(options) {
    const resp = await api.FileApi.uploadFile(body, options);
    return resp;
  };
});
const uploadFileViaPresignedUrlSilentAsync = createSilentAsync(body => {
  return async function uploadFileViaPresignedUrlSilent(options) {
    const resp = await api.FileApi.uploadFileViaPresignedUrl(body, options);
    return resp;
  };
});

// const getPresignedFileUploadUrlAsync = createAsync(() => {
//   return async function getPresignedFileUploadUrl(this, options) {
//     const resp = await api.FileApi.getPresignedFileUploadUrl(options);
//
//     return resp;
//   };
// });
//
// const setPresignedFileUploadUrlAsync = createAsync(body => {
//   return async function setPresignedFileUploadUrl(this, options) {
//     const resp = await api.FileApi.setPresignedFileUploadUrl(body, options);
//
//     return resp;
//   };
// });

const getPresignedFileDownloadUrlAsync = createAsync(body => {
  return async function getPresignedFileDownloadUrl(options) {
    const resp = await api.FileApi.getPresignedFileDownloadUrl(body, options);
    return resp;
  };
});
const getPresignedFileArchiveDownloadUrlAsync = createAsync(body => {
  return async function getPresignedFileArchiveDownloadUrl(options) {
    const resp = await api.FileApi.getPresignedFileArchiveDownloadUrl(body, options);
    return resp;
  };
});
const getRequestPreviewLinkAsync = createAsync(body => {
  return async function getRequestPreviewLink(options) {
    const resp = await api.FileApi.requestPreviewLink(body, options);
    return resp;
  };
});

// const convertToImageAsync = createAsync(body => {
//   return async function convertToImage(this, options) {
//     const resp = await api.FileApi.convertToImage(body, options);
//
//     return resp;
//   };
// });

const convertToImageByIdAsync = createAsync(body => {
  return async function convertToImageById(options) {
    const resp = await api.FileApi.convertToImageById(body, options);
    return resp;
  };
});
const EditFileFormDates = types.model({
  endDate: types.maybeNull(types.string),
  startDate: types.maybeNull(types.string)
});
const EditFileForm = types.model({
  amount: types.maybeNull(types.union(types.number, types.string)),
  commonAreaDeduction: types.maybeNull(types.union(types.number, types.string)),
  goodwillDeduction: types.maybeNull(types.union(types.number, types.string)),
  date: EditFileFormDates
});
const File = types.model('File', {
  fileName: types.string,
  uploadedOn: types.string
});
const FileApiStore = types.model('FileApiStore', {
  fileDataById: types.map(File),
  getFileInfoAsync,
  getFilesInfoAsync,
  isFileUploadingAcceptedFlag: types.optional(types.boolean, false),
  uploadFileAsync,
  deleteFileAsync,
  uploadFileViaPresignedUrlExperimentAsync,
  uploadFileSilentAsync,
  uploadFileViaPresignedUrlSilentAsync,
  // getPresignedFileUploadUrlAsync,
  // setPresignedFileUploadUrlAsync,
  getPresignedFileDownloadUrlAsync,
  getPresignedFileArchiveDownloadUrlAsync,
  getRequestPreviewLinkAsync,
  // convertToImageAsync,
  convertToImageByIdAsync,
  drawType: types.optional(types.string, ''),
  drawIndex: types.optional(types.number, 1),
  viewIndex: types.optional(types.number, 95),
  drawForm: types.optional(EditFileForm, {
    amount: '',
    commonAreaDeduction: null,
    goodwillDeduction: null,
    date: {
      endDate: '',
      startDate: ''
    }
  })
}).actions(store => {
  return {
    drawIndexIncrement() {
      try {
        store.drawIndex++;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    drawIndexDecrement() {
      try {
        --store.drawIndex;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    drawIndexReset() {
      try {
        store.drawIndex = 1;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    viewIndexIncrement() {
      try {
        store.viewIndex += 10;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    viewIndexDecrement() {
      try {
        store.viewIndex -= 10;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    viewIndexReset() {
      try {
        store.viewIndex = 95;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeDraw(data) {
      try {
        if (store.drawType === data) {
          store.drawType = '';
        } else {
          store.drawType = data;
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeDrawForm(data) {
      try {
        store.drawForm = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetDrawForm() {
      try {
        store.drawForm = {
          amount: '',
          commonAreaDeduction: null,
          goodwillDeduction: null,
          date: {
            endDate: '',
            startDate: ''
          }
        };
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    getFileUploadingAccepted() {
      try {
        store.isFileUploadingAcceptedFlag = localStorage.getItem('livable_allocations_file_upload_flag') === 'accepted';
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFileNamesByIds(data) {
      try {
        data.response.forEach(file => {
          store.fileDataById.set(file.fileId, file);
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFileUploadingAccepted() {
      try {
        store.isFileUploadingAcceptedFlag = true;
        localStorage.setItem('livable_allocations_file_upload_flag', 'accepted');
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  getFilePreviewLink(body) {
    let addToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let ext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.docx';
    return api.FileApi.downloadFilePreviewLink(body, addToken, ext);
  },
  get isFileUploadingAccepted() {
    return store.isFileUploadingAcceptedFlag;
  }
}));
export const files = types.optional(FileApiStore, {});